import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50f9587a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "marketing-consent-page" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p data-v-50f9587a> 테라사이클코리아(유)/(이하 “회사”)는 “정보통신망 이용촉진 및 정보보호에 관한 법률”, “개인정보보호법” 등 관계 법령에 따라 광고성 정보를 전송하기 위해 수신자의 사전 수신 동의를 받고 있으며, 광고성 정보 수신자의 수신 동의 여부를 정기적으로 확인합니다. 다만 동의하지 않을 경우, 상품/서비스 소개 및 권유, 사은행사, 판촉 행사 등 이용 목적에 따른 혜택에 제한이 있을 수 있습니다. </p><section data-v-50f9587a><h2 data-v-50f9587a>01 목적</h2><ul data-v-50f9587a><li data-v-50f9587a>문자 메시지, 이메일 등을 통한 광고성 정보 전송</li><li data-v-50f9587a>새로운 신규 캠페인 및 이벤트 정보 안내</li><li data-v-50f9587a>혜택, 이벤트, 광고 등 마케팅에 활용</li></ul></section><section data-v-50f9587a><h2 data-v-50f9587a>02 이용 항목</h2><p data-v-50f9587a>휴대폰 번호, 이메일주소</p></section><section data-v-50f9587a><h2 data-v-50f9587a>03 보유 및 이용 기간</h2><p data-v-50f9587a>광고성 정보 수신 동의일로부터 탈퇴 또는 별도 동의 철회 시, 약관 철회 후 2주일까지</p></section><p class=\"notice\" data-v-50f9587a> * 본 동의는 선택 동의로서 거부하실 수 있으며, 거부하시더라도 서비스 이용에는 제한이 없습니다. <br data-v-50f9587a> * 광고성 정보 수신 동의/해제는 언제든지 마이페이지-프로필 수정을 통해 변경하실 수 있습니다. </p>", 5)

import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const title = '(선택) 광고성 정보 수신 동의 안내';

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, {
      class: "page-breadcurmb",
      routes: [
        {
          name: _unref(t)('Home'),
          to: '/'
        },
        {
          name: title
        }
      ]
    }, null, 8, ["routes"]),
    _createElementVNode("article", { class: "content" }, [
      _createElementVNode("h1", null, _toDisplayString(title)),
      _hoisted_2
    ])
  ]))
}
}

})